module.exports = __webpack_public_path__ + "img/pmb2.31b51e73.jpg";